import { Component, ElementRef, Input, QueryList, ViewChildren } from '@angular/core';
import { ControlValueAccessorModel, getProvider } from '../../models/control-value-accessor.model';
import { TextInputComponent } from '../TextInput/text-input.component';
import { ButtonTypesEnum } from '../../enums/button-types.enum';


/**
 * ### Accessibility Usage
 * + ***ariaLabel*** - use this to provide an accessible label for the search field, if label is not provided
 * + ***id*** - provide an unique id so that this component can be correctly recognized by screen readers. Use interpolation [id]="'unique_id'"
 */
@Component({
    selector: 'agpr-multi-text-input',
    templateUrl: './multi-text-input.component.html',
    styleUrls: ['./multi-text-input.component.scss'],
    providers: [getProvider(MultiTextInputComponent)],
    standalone: false
})
export class MultiTextInputComponent extends ControlValueAccessorModel<string[]> {
    readonly buttonTypes = ButtonTypesEnum;

    @Input() public id: string;
    @Input() public isEditing: boolean = true;
    @Input() public label: string;
    @Input() public placeholder: string;
    @Input() public required: boolean = false;
    @Input() public disabled: boolean = false;
    @Input() public minItems: number = 1;
    @Input() public maxItems: number;
    @Input() public maxItemLength: number;
    @Input() public bottomMargin: boolean = true;
    // Must be provided for accessibility if no visible label provided
    @Input() public ariaLabel: string;

    @ViewChildren(TextInputComponent) inputs: QueryList<TextInputComponent>;

    addItem(): void {
        this.value.push(undefined);
        setTimeout(() => this.inputs.last.giveFocus());
        this.onModelChange(this.value);
    }
    removeItem(index: number): void {
        this.value.splice(index, 1);
        setTimeout(() => {
            if (!!this.inputs.get(index)) {
                this.inputs.get(index).giveFocus();
            } else {
                this.inputs.last.giveFocus();
            }
        });
        this.onModelChange(this.value);
    }
    writeValue(value: string[]): void {
        if (!value) {
            return;
        }
        if (value.length < this.minItems) {
            value.push(...new Array(this.minItems - value.length));
        }
        this.value = value;
    }
    trackByFn(index: any, item: any) {
        return index;
    }
}
